/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentactivator": {
        "nested": {
          "ActivationState": {
            "values": {
              "NOT_ACTIVE": 0,
              "PROVISIONAL": 1,
              "OPTIMISTIC": 2,
              "ACTIVATED": 3,
              "DEACTIVATED": 4,
              "ALMOST": 5
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentactivator?.nested?.ActivationState) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActivationState @ squareup/paymentactivator/activations.proto at 11:1
 */
export const ActivationState = $root.lookupEnum('squareup.paymentactivator.ActivationState').values;